import { create } from 'zustand';
import { authService } from '../services/authService';
import { setTelemetryUser } from '../services/telemetry';

interface AuthState {
  status: 'loading' | 'signedOut' | 'signedIn' | 'error';
  uid: string | null;
  error: string | null;
  /** Subscribe to Firebase auth. Returns an unsubscribe. Call once at startup. */
  init: () => () => void;
  signIn: () => Promise<void>;
  signOut: () => Promise<void>;
}

export const useAuth = create<AuthState>((set) => ({
  status: 'loading',
  uid: null,
  error: null,
  init: () =>
    authService.onChange(
      (user) => {
        setTelemetryUser(user?.uid ?? null);
        set({ status: user ? 'signedIn' : 'signedOut', uid: user?.uid ?? null, error: null });
      },
      (e) => set({ status: 'error', error: e.message }),
    ),
  signIn: () => authService.signInWithGoogle(),
  signOut: () => authService.signOut(),
}));
